import { HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { TraceService } from 'app/shared/services';

export const httpTraceInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
    const traceService = inject(TraceService);
    const startedAtMs = Date.now();

    return next(req)
        .pipe(
            tap((event) => {
                if (event instanceof HttpResponse) {
                    traceService.http({
                        method: req.method,
                        url: req.urlWithParams,
                        status: event.status,
                        durationMs: Date.now() - startedAtMs,
                        payload: req.body,
                        response: event.body
                    });
                }
            }),
            catchError((err: unknown) => {
                traceService.http({
                    method: req.method,
                    url: req.urlWithParams,
                    status: err instanceof HttpErrorResponse ? err.status : 500,
                    durationMs: Date.now() - startedAtMs,
                    payload: req.body,
                    response: err instanceof HttpErrorResponse ? err.error : err
                }, true);

                return throwError(() => err);
            })
        );
};
